<template>
	<form-remote-select v-bind="props"
						@update:modelValue="value => emit('update:modelValue', value)"
						:action="`/v1/countries/${props.country}/states/options`"
						text-prop="locale_name"
						subtitle-prop="_key"
						value-prop="_key"
						:remote="false"
						as-guest/>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
	// The country code to filter the states by
	country?: string,
}>(), {});
const emit = defineEmits(['update:modelValue']);
</script>